import React from 'react';
import { PracticalInfoPage } from './PracticalInfoPage';

export function RulesPage() {
  return <PracticalInfoPage />;
}
